<template>
   <div
      class="flip-chebox--label-container"
      :class="{'flip-chebox--label-container__reverse': right}"
      @click="changeCheck"
   >
      <div
         class="flip-chebox--container"
         :class="{
            'flip-chebox--container__radio': radio,
            'flip-chebox--container__outlined': outlined,
            [componeBorderColor(color_true)]: check,
            [componeBorderColor(color_false)]: !check,
         }"
         :style="'transform: translateY(-4px) scale(' + scale + ')'"
      >
         <div
            class="flip-chebox"
            :class="{
               'no_animation': !delay_mounted_1000,
               'flip-chebox__true': check,
               'flip-chebox__false': !check,
               'flip-chebox__outlined': outlined,
            }"
         >
            <div class="flip-chebox--face flip-chebox--true">
               <v-icon
                  :small="outlined"
                  :color="color_true"
               >
                  mdi-{{icon_true}}
               </v-icon>
            </div>
            <div class="flip-chebox--face flip-chebox--false">
               <v-icon
                  :small="outlined"
                  :color="color_false"
               >
                  mdi-{{icon_false}}
               </v-icon>
            </div>
         </div>
      </div>
      <div
         class="flip-chebox--label"
         :class="{
            ['!text-' + (!disable_text_color ? color_true : '')]: check,
            ['!text-' + (!disable_text_color ? color_false : '')]: !check,
         }"
         v-html="label"
      >
      </div>
   </div>
</template>

<script>
export default {
   props: {
      disabled: {
         type: Boolean,
      },
      check: {
         type: Boolean,
      },
      check_array: {
         type: Array,
      },
      label: {
         type: String,
      },
      radio: {
         type: Boolean,
      },
      outlined: {
         type: Boolean,
      },
      scale: {
         type: String,
         default: '.7'
      },
      icon_true: {
         type: String,
         default: 'check-bold'
      },
      icon_false: {
         type: String,
         default: 'minus-thick'
      },
      disable_text_color: {
         type: Boolean,
         default: false
      },
      color_true: {
         type: String,
         default: 'green'
      },
      color_false: {
         type: String,
         default: 'grey'
      },
      right: {
         type: Boolean,
      },
   },
   methods: {
      componeBorderColor(color){
         return "!border-[" + color + "]"
      },
      changeCheck() {
         if(!this.disabled)
            this.$emit('changeCheck')
      }
   },
};
</script>

<style lang="scss" scoped>
/*  */
.flip-chebox{
   display: inline-block;
  width: fit-content;
  position: relative;
  transform-style: preserve-3d;
  transform: rotateY(0deg);

  &__true{
    animation: checkToTrue 0.275s forwards linear;
  }
  &__false{
    animation: checkToFalse 0.275s forwards linear;
  }

  &--face{
    position: absolute;
    backface-visibility: hidden;
  }
  &--true{
    position: absolute;
    z-index: 4;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    transform: rotateY(180deg);
  }
  &--false{
    position: relative;
  }

   &--container{
      width: fit-content;
      transition: border-color .3s ease;

      &__outlined{
         max-height: 30px;
         display: flex;
         align-items: center;
         justify-content: center;
         padding: .4rem;
         border-radius: 4px;
         border: 3px solid;

      }
      &__radio{
         border-radius: 100px !important;
      }

   }
   &--label-container{
      cursor: pointer;
      pointer-events: all;
      display: flex;
      align-items: flex-start;
      gap: 7px;

      &__reverse{
         flex-direction: row-reverse;
      }
   }

   &--label{
      transition: color .3s ease;

      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
   }


}

@keyframes checkToFalse {
   0% {
      transform: rotateZ(0deg) rotateY(180deg);
   }
   50% {
      transform: rotateZ(-140deg) rotateY(90deg);
   }
   100% {
      transform: rotateZ(0deg) rotateY(0deg);
   }
}

@keyframes checkToTrue {
   0% {
      transform: rotateZ(0deg) rotateY(0deg);
   }
   50% {
      transform: rotateZ(-140deg) rotateY(90deg);
   }
   100% {
      transform: rotateZ(0deg) rotateY(180deg);
   }
}
</style>
